import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import classes from './SocialMediaLinks.module.css';
import { socialMedia } from '../../../data';
import googleAnalytics from '../../../utils/googleAnalytics';

const SocialMediaLinks = ({ color }) => {
  const hub = useSelector((state) => state.hub.hub);

  return (
    <div className={classes.socialMedia}>
      {socialMedia.map(({ id, link }) => (
        <a
          href={link}
          key={id}
          target="_blank"
          rel="noreferrer"
          onClick={() =>
            googleAnalytics({
              event: 'outboundLink',
              link_url: link,
              link_title: id,
              section_title: hub.name,
            })
          }
        >
          <img
            className={classes.socialImage}
            src={`/images/${id}-${color}.svg`}
            alt="social-media"
          />
        </a>
      ))}
    </div>
  );
};

SocialMediaLinks.propTypes = {
  color: PropTypes.string,
};

SocialMediaLinks.defaultProps = {
  color: 'white',
};

export default SocialMediaLinks;
